const compSize = {
    rootHeight:   140,
    rootWidth:    400,
    gap:          5,
    submitHeight: 55
} 

export default compSize;